import { useEffect, useState } from 'react';
import { TwButton, TwInputGroup, TwLabel, TwLoadingIcon, TwSelectGroup } from '../../components/tailwind';
import { useLocalStorage } from '../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { loadingState, setGlobalLoading } from '../../redux/reducers/loadingReducer';
import { userState } from '../../redux/reducers/userReducer';
import { getUrlForEvent } from "../../utils/confighelpers";
import axiosInstance from '../../utils/axiosInstance';
import { useToast } from '../../provider/ToastProvider';
import { Radio, RadioGroup } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import PayoutStatus from './PayoutStatus';

export default function PayoutScheduleForm({ reload }) {
     const { t, i18n } = useTranslation();
     const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
     const [userToken] = useLocalStorage("userToken");
     const dispatch = useDispatch();
     const loadingReduxState = useSelector(loadingState);
     const userReduxState = useSelector(userState);
     const [interval, setInterval] = useState('daily');
     const [delayDays, setDelayDays] = useState(2);
     const [weeklyAnchor, setWeeklyAnchor] = useState('monday');
     const [monthlyAnchor, setMonthlyAnchor] = useState(1);
     const [loading, setLoading] = useState(false);
     const [isThereStripeChange, setIsThereStripeChange] = useState(true);
     const [errors, setErrors] = useState({});


     const getStripeAccountDetail = async (loading = true) => {
          setLoading(true)
          dispatch(setGlobalLoading(loading));
          const apiConfig = {
               method: "POSt",
               url: `${getUrlForEvent()}payments/getStripeAccountDetail`,
          };
          const apiRequest = await axiosInstance(apiConfig);
          dispatch(setGlobalLoading(false));
          setLoading(false)
          if (apiRequest.status === 200) {
               if (apiRequest.data.statusCode === 200) {
                    setInterval('daily')
                    setDelayDays(2)
                    setWeeklyAnchor('monday')
                    setMonthlyAnchor(1)
                    setIsThereStripeChange(true)
                    if (apiRequest.data.data?.settings && apiRequest.data.data?.settings?.payouts) {
                         let payoutSettings = apiRequest.data.data?.settings?.payouts
                         if (payoutSettings.schedule) {
                              let payoutSettingsSchedule = payoutSettings.schedule;
                              setInterval(payoutSettingsSchedule?.interval || 'daily')
                              if (payoutSettingsSchedule.delay_days) {
                                   setDelayDays(payoutSettingsSchedule.delay_days || 2)
                              }
                              if (payoutSettingsSchedule.weekly_anchor) {
                                   setWeeklyAnchor(payoutSettingsSchedule.weekly_anchor || 'monday')
                              }
                              if (payoutSettingsSchedule.monthly_anchor) {
                                   setMonthlyAnchor(payoutSettingsSchedule.monthly_anchor || 1)
                              }

                         }

                    }
               }
          }
     };
     const updateStripeAccountDetail = async (schedule) => {
          dispatch(setGlobalLoading(true));
          const apiConfig = {
               method: "POSt",
               url: `${getUrlForEvent()}payments/updateStripeAccountDetail`,
               data: {
                    settings: {
                         payouts: {
                              schedule: schedule,
                              // statement_descriptor: 'YourBusiness'
                         }
                    }
               },
          };
          let apiRequest;
          try {
               apiRequest = await axiosInstance(apiConfig);
          } catch (e) {
               dispatch(setGlobalLoading(false));
               addErrorToast(e?.response?.data?.message || t("errors.somethingIsWrong"));
               // Stripe kept its previous schedule, so re-read it rather than leaving the
               // form showing a selection that was never applied.
               getStripeAccountDetail(false);
               return;
          }
          dispatch(setGlobalLoading(false));

          const succeeded =
               apiRequest?.status === 200 &&
               apiRequest?.data?.statusCode === 200 &&
               !apiRequest?.data?.data?.message;

          if (!succeeded) {
               addErrorToast(
                    apiRequest?.data?.data?.message ||
                    apiRequest?.data?.message ||
                    t("errors.somethingIsWrong")
               );
               getStripeAccountDetail(false);
               return;
          }

          setIsThereStripeChange(true)
          addNotificationDialog({
               dialogType: "success",
               dialogTitle: t("successes.paymentProfileChangedSuccTitle"),
               dialogMessage: t("successes.paymentProfileChangedSuccSubTitle2"),
               dialogBtnTitle: t("inputFieldsTitle.ok"),
          })
          // Confirm against Stripe rather than trusting the local selection.
          getStripeAccountDetail(false);
     };

     const validate = () => {
          const newErrors = {};

          if (interval !== 'manual' && (delayDays === '' || isNaN(delayDays) || delayDays < 7)) {
               newErrors.delay_days = t("errors.delayMustBeMsg");
          }

          if (interval === 'monthly') {
               if (
                    monthlyAnchor === '' ||
                    isNaN(monthlyAnchor) ||
                    monthlyAnchor < 1 ||
                    monthlyAnchor > 31
               ) {
                    newErrors.monthly_anchor = t("errors.monthlyAnchorMustBeMsg");
               }
          }

          setErrors(newErrors);
          return Object.keys(newErrors).length === 0;
     };

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!validate()) return;

          const schedule = {
               interval,
               // Stripe rejects delay_days / anchors on a manual schedule.
               ...(interval === 'daily' && { delay_days: parseInt(delayDays) }),
               ...(interval === 'weekly' && { weekly_anchor: weeklyAnchor, delay_days: 7 }),
               ...(interval === 'monthly' && { monthly_anchor: parseInt(monthlyAnchor), delay_days: 7 }),
          };
          await updateStripeAccountDetail(schedule);
     };

     useEffect(() => {
          getStripeAccountDetail(false);
     }, []);

     useEffect(() => {

          let stripeprofileDetails = userReduxState?.userData?.myConnectedPaymentProfiles?.stripe ?? {}

     }, [])


     return loading ? (
          <div className={"h-28 w-full grid place-items-center"}>
               <TwLoadingIcon />
          </div>
     ) : (
          <form onSubmit={handleSubmit} className="space-y-5">


               {/* Interval */}
               {/* <TwSelectGroup
                    label={t("inputFieldsTitle.payoutIntervalTitle")}
                    name={"payout_interval"}
                    options={[
                         // { value: "manual", title: "Manual" },
                         { value: "daily", title: "Daily" },
                         { value: "weekly", title: "Weekly" },
                         { value: "monthly", title: "Monthly" },
                    ]}
                    value={interval}
                    onChange={(e) => {
                         setInterval(e.target.value)
                         setIsThereStripeChange(false)
                    }}
                    errors={errors} /> */}
               <fieldset aria-label="Payout Interval">
                    <TwLabel>{t("inputFieldsTitle.payoutIntervalTitle")}</TwLabel>
                    <RadioGroup

                         value={interval || 'daily'}
                         onChange={(value) => {
                              setInterval(value)
                              setIsThereStripeChange(false)
                         }}
                         className={"rounded-full bg-white/5 p-1 text-xs/5 font-semibold text-gray-900"}
                    >
                         <div className="flex flex-wrap gap-x-6 gap-y-2">
                              {['manual', 'daily', 'weekly', 'monthly'].map((option) => (
                                   <Radio
                                        key={option}
                                        value={option}
                                        className="flex items-center space-x-3 cursor-pointer"
                                   >
                                        {({ checked }) => (
                                             <>
                                                  <span
                                                       className={`h-5 w-5 rounded-full border-2 flex items-center justify-center ${checked ? 'border-blue-600' : 'border-gray-300'
                                                            }`}
                                                  >
                                                       {checked && <span className="h-2.5 w-2.5 bg-blue-600 rounded-full" />}
                                                  </span>
                                                  <span className="text-gray-900 font-medium capitalize">{option}</span>
                                             </>
                                        )}
                                   </Radio>
                              ))}
                         </div>
                    </RadioGroup>
               </fieldset>

               {/* Delay Days */}
               {false && (<TwInputGroup
                    label={t("inputFieldsTitle.delayDaysTitle")}
                    placeholder={t("inputFieldsTitle.delayDaysTitle")}
                    type={"number"}
                    name={"delay_days"}
                    value={delayDays} onChange={(e) => {
                         setDelayDays(e.target.value)
                         setIsThereStripeChange(false)
                    }}
                    errors={errors}
               />)}

               {/* Weekly Anchor */}
               {false && interval === 'weekly' && (
                    <TwSelectGroup
                         label={t("inputFieldsTitle.weeklyAnchorTitle")}
                         name={"weekly_anchor"}
                         options={
                              ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'].map((day) => { return { value: day, title: day.charAt(0).toUpperCase() + day.slice(1) } })
                         }
                         value={weeklyAnchor}
                         onChange={(e) => {
                              setWeeklyAnchor(e.target.value)
                              setIsThereStripeChange(false)
                         }}
                         errors={errors} />
               )}

               {/* Monthly Anchor */}
               {false && interval === 'monthly' && (
                    <TwInputGroup
                         label={t("inputFieldsTitle.monthlyAnchorTitle")}
                         placeholder={t("inputFieldsTitle.monthlyAnchorTitle")}
                         type={"number"}
                         name={"monthly_anchor"}
                         value={monthlyAnchor} onChange={(e) => {
                              setMonthlyAnchor(e.target.value)
                              setIsThereStripeChange(false)
                         }}
                         errors={errors}
                    />
               )}

               {isThereStripeChange ? (
                    <PayoutStatus
                         interval={interval}
                         delayDays={delayDays}
                         weeklyAnchor={weeklyAnchor}
                         monthlyAnchor={monthlyAnchor}
                    />
               ) : null}

               {/* Submit Button */}
               <div className={"flex flex-row items-center gap-2"}>
                    <TwButton
                         variant={"secondary"}
                         type="submit"
                         className="sm:min-w-32"
                         disabled={loadingReduxState.actionLoading || isThereStripeChange}
                         actionLoading={(loadingReduxState.actionLoading)}
                         onClick={async () => {

                         }}
                    >
                         {t("update")}
                    </TwButton>
               </div>
          </form>
     );
}
